// Phase 92D — normalize a GET /development-reports/{id} response into a single
// presentation model consumed by ReportDocument (draft + finalized alike).
export function buildPresentation(data) {
  const report = data.report || {};
  const isDraft = report.status === 'draft';
  const snapshot = data.snapshot || null;
  const sections = isDraft ? (data.assembled || {}) : (snapshot?.sections || {});
  const overview = isDraft
    ? (sections?.overview?.data || null)
    : (snapshot?.athlete || sections?.overview?.data || null);

  const pick = (draftVal, snapVal, fallback) =>
    (isDraft ? draftVal : snapVal) ?? fallback;

  const eff = {
    ...report,
    selected_sections: pick(report.selected_sections, snapshot?.selected_sections, report.selected_sections || []),
    development_summary: pick(report.development_summary, snapshot?.development_summary, ''),
    strengths: pick(report.strengths, snapshot?.strengths, []),
    priorities: pick(report.priorities, snapshot?.priorities, []),
    selected_evidence: pick(report.selected_evidence, snapshot?.selected_evidence, []),
    staff_assessments: pick(report.staff_assessments, snapshot?.staff_assessments, {}),
    section_config: pick(report.section_config, snapshot?.section_config, {}),
    football_areas: pick(report.football_areas, snapshot?.football_areas, []),
    manual_targets: pick(report.manual_targets, snapshot?.manual_targets, []),
    custom_sections: pick(report.custom_sections, snapshot?.custom_sections, []),
    section_summaries: pick(report.section_summaries, snapshot?.section_summaries, {}),
    section_evidence: pick(report.section_evidence, snapshot?.section_evidence, {}),
    physical_gps_analysis_notes: pick(report.physical_gps_analysis_notes, snapshot?.physical_gps_analysis_notes, []),
    primary_focus: pick(report.primary_focus, snapshot?.primary_focus, ''),
    key_message: pick(report.key_message, snapshot?.key_message, ''),
    next_review_date: pick(report.next_review_date, snapshot?.next_review_date, ''),
    snapshot,
  };

  const lead = report.lead_reviewer || snapshot?.lead_reviewer || report.created_by_name || snapshot?.finalized_by_name || null;
  return { report: eff, sections, overview, isDraft, lead };
}

// Safe filename for the downloadable PDF (client-side hint only; backend also
// sanitizes). e.g. PFAP_Player_Development_Report_Iman_Kydyraliev_2026-09.pdf
export function pdfFilename(report, overview) {
  const name = (overview?.full_name || report?.athlete_name || 'Athlete')
    .normalize('NFKD').replace(/[^\w\s-]/g, '').trim().replace(/\s+/g, '_');
  const d = (report?.report_date || report?.review_end_date || '').slice(0, 7) || 'report';
  return `PFAP_Player_Development_Report_${name}_${d}.pdf`;
}
